export const SET_SIGNUP_API_RESPONSE = 'SET_SIGNUP_API_RESPONSE';
